<template>
  <div class="container mt-2">
    <div class="section">
      <div class="columns is-centered">
        <div class="column is-6">
          <div class="box has-text-centered">
            <span class="icon is-large has-text-success mb-4">
              <i class="fa fa-check-circle fa-3x"></i>
            </span>
            <h1 class="title is-4 has-text-success">
              {{ $t("process completed successfully") }}
            </h1>
            <p class="subtitle is-6">
              {{ $t("personal savings account request submitted") }}
            </p>
            <!-- <button @click="returnToDashboard" class="button is-primary mt-4">
              <span class="icon">
                <i class="fa fa-home"></i>
              </span>
              <span>{{ $t("return to dashboard") }}</span>
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  warning_message,
  get,
  generate_error_message_text,
  post,
  format_date,
  success_message,
  drive_static_file_url,
} from "@/utils";
import moment from "moment";

export default {
  name: "PersonalSavingsAccountRequestProcessFinished",
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    returnToDashboard() {
      this.$router.push("/dashboard");
    },
  },
  mounted() {},
};
</script>

<style scoped>
.box {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.icon.is-large {
  display: block;
  margin: 0 auto 1rem;
}
</style>
